//#region imports
import React, { useEffect, useState } from "react";

// custom components
import { CustomSpinner } from "_atoms";
import { ActionsModal } from "_molecules";

// bootstrap
import Button from "react-bootstrap/esm/Button";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectAcceptUnplanedTaskStatus, acceptUnplannedTask, selectAcceptUnplanedTaskError, selectDeleteTaskError, selectDeleteTaskStatus, } from "_redux/slices/timeline/timeline-data";
import { selectEmployeeList } from "_redux/slices/timeline/employees";
import { unplanTask } from '_redux/slices/timeline/timeline-data';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';

// styling
import { Colors, Spacing } from "_styles";

// icons
import { CiCirclePlus } from "react-icons/ci";

//#endregion

const TaskAccept = (props) => {

  //#region redux
  const dispatch = useDispatch();

  // 
  const acceptUnplanedTaskStatus = useSelector(selectAcceptUnplanedTaskStatus);
  const acceptUnplanedTaskStatusError = useSelector(selectAcceptUnplanedTaskError);

  // list of employees
  const employeeList = useSelector(selectEmployeeList);

  // delete status
  const deleteTaskStatus = useSelector(selectDeleteTaskStatus);
  const deleteTaskError = useSelector(selectDeleteTaskError);

  const dbUser = useSelector(selectFirebaseInfo);                                       // logged in user

  //#endregion

  //#region local states

  const [employeeName, setEmployeeName] = useState("");   // hold employee name
  const [taskType, setTaskType] = useState("Transit");    // hold task type (transit,unplanned)
  const [error, setError] = useState("");                 // hold any errors

  //#endregion

  //#region useEffect

  // close modal if the task is accepted or deleted
  useEffect(() => {
    if (acceptUnplanedTaskStatus == "succeeded" || deleteTaskStatus == "succeeded") {
      props?.closeModal();
      setError("");
    }
  }, [acceptUnplanedTaskStatus, deleteTaskStatus]);

  // check if booking is transit or unplanned booking
  useEffect(() => {
    if (props.task) {
      const taskType = props.task?.isTransitBooking ? "Transit" : "Unplanned";
      setTaskType(taskType)
    }
  }, [props.task]);

  // check if there is any error
  useEffect(() => {
    if (deleteTaskError) setError(deleteTaskError);
    if (acceptUnplanedTaskStatusError) setError(acceptUnplanedTaskStatusError);
  }, [deleteTaskError, acceptUnplanedTaskStatusError]);

  // find the employee name from the employee list
  useEffect(() => {
    let employee = employeeList.find((employee) => employee?.employeeId == props?.task?.employeeId);
    if (employee) setEmployeeName(employee?.title);
  }, [props?.task, employeeList]);

  //#endregion

  //#region functions

  // accept task and update the task
  const handleAcceptTask = () => {
    dispatch(acceptUnplannedTask({ ...props?.task, pending: false }));
  };

  // reject task and delete the task
  const handleRejectTask = () => {

    // check we have task id
    if (props?.task && props?.task["_id"] != undefined) {
      const params = { taskId: props.task?._id, iata: dbUser.details.authority }
      dispatch(unplanTask(params));
    }
  };

  //#endregion

  return (
    <ActionsModal show={props.toggleAcceptModal} handleClose={props.closeModal} title="Accept Task" minWidth="445px" maxWidth="445px" isTimeline={true}>

      {/* modal body */}
      <div style={{ borderStyle: 'solid', borderWidth: 1 }}>

        {/* task details */}
        <div style={{ padding: Spacing.SCALE_12, opacity: acceptUnplanedTaskStatus == "loading" ? 0.2 : 1.0, zIndex: "initial" }} >

          <div style={{ display: "flex", marginLeft: Spacing.SCALE_12, marginBottom: Spacing.SCALE_22, borderStyle: 'solid', borderWidth: 1 }}>
            <div style={{ padding: Spacing.SCALE_18, display: "flex", alignItems: "center", backgroundColor: Colors.LIGHT_GREEN, borderRadius: 10, borderLeftWidth: 3, borderLeftStyle: "solid", borderLeftColor: Colors.DARK_GREEN }}>
              <CiCirclePlus size={40} color={Colors.DARK_GREEN} />
              <p style={{ color: Colors.DARK_GREEN, display: "flex", alignItems: "center", margin: 0, marginLeft: Spacing.SCALE_12 }}>{`This task has been created by employee ${employeeName} as ${taskType} task`}</p>
            </div>
            <p>{error ? error : ""}</p>
          </div>

          {/* buttons */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="danger"
              onClick={handleRejectTask}
              style={{ marginRight: Spacing.SCALE_12 }}
            >
              {"Reject Task"}
            </Button>
            <Button variant="primary" onClick={handleAcceptTask}>
              {"Accept Task"}
            </Button>
          </div>
        </div>
        {(acceptUnplanedTaskStatus == "loading" ||
          deleteTaskStatus == "loading") && (
            <div style={{ position: "absolute", left: "45%", top: "40%" }}>
              <CustomSpinner />
            </div>
          )}

      </div>

    </ActionsModal>
  );
};

export default React.memo(TaskAccept);